export default __webpack_public_path__ + "media/buildings/NewDev_AdUnit-9fb2b140.png";